import { Center, Typography } from '@omnipresentgroup/design-system';

export const Home = () => {
  return (
    <Center centerChildren pt="64">
      <Typography as="h1" size="24" hideParagraphSpacing>
        Manager dashboard
      </Typography>
    </Center>
  );
};
